import React from "react";
import { EnrollmentContainer } from "../../../containers";

const Enrollment = (props) => {
  return <EnrollmentContainer {...props} />;
};

export default Enrollment;
